import { useContext, useEffect, useRef, useState } from 'react';

import { GlobalContext } from '@/app/providers/globalState';
import { data_from_server_post } from '@/shared/http/client';

const CLIENT_ID = '40b3a00e282ee2db1338c3bba881b99125fc3ba1d7f5c29232ce1ad63fab1e75';

/**
 * True when the platform has no tasks and no org-level datasets/benchmarks.
 * Used to trim the navbar to Projects + Docs on first-time empty orgs.
 */
export function useIsPlatformEmpty() {
    const { allUsecases, isFetchingUsecases } = useContext(GlobalContext);
    const [hasOrgDatasets, setHasOrgDatasets] = useState(null);
    const fetchedForEmptyRef = useRef(false);

    useEffect(() => {
        if (isFetchingUsecases) {
            return;
        }

        if (allUsecases.length > 0) {
            setHasOrgDatasets(true);
            fetchedForEmptyRef.current = false;
            return;
        }

        if (fetchedForEmptyRef.current) {
            return;
        }
        fetchedForEmptyRef.current = true;

        data_from_server_post(
            'datasets',
            { client_id: CLIENT_ID },
            (response) => {
                const count =
                    (response?.datasets || []).length +
                    (response?.benchmarks || []).length +
                    (response?.manual_model_predictions || []).length;
                setHasOrgDatasets(count > 0);
            },
            () => {
                setHasOrgDatasets(false);
            }
        );
    }, [allUsecases.length, isFetchingUsecases]);

    const isPlatformEmpty =
        !isFetchingUsecases &&
        allUsecases.length === 0 &&
        hasOrgDatasets === false;

    return { isPlatformEmpty };
}
